import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useApp } from "../context/AppContext";
import { BrandLogo } from "../components/BrandLogo";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
// Callback route for native Google OAuth. Google redirects here with ?code=xxx
// after the user consents. We POST the code to the backend which exchanges it
// for tokens, upserts the user by email, and sets our HttpOnly session cookie.
const GoogleCallback = () => {
    const navigate = useNavigate();
    const { setUser } = useApp();
    const processed = useRef(false);

    useEffect(() => {
        if (processed.current) return;
        processed.current = true;
        const params = new URLSearchParams(window.location.search);
        const code = params.get("code");
        const err = params.get("error");
        if (err || !code) {
            navigate("/?auth_error=1");
            return;
        }
        const redirect_uri = window.location.origin + "/auth/google";
        (async () => {
            try {
                const res = await api.post("/auth/google/exchange", { code, redirect_uri });
                setUser(res.data.user);
                try { window.sessionStorage.setItem("vlg_just_logged_in", "1"); } catch (_) {}
                window.history.replaceState({}, "", "/dashboard");
                navigate("/dashboard", { state: { user: res.data.user } });
            } catch (e) {
                navigate("/?auth_error=1");
            }
        })();
    }, [navigate, setUser]);

    return (
        <div className="min-h-screen grid place-items-center bg-[hsl(var(--background))]">
            <div className="flex items-center gap-3 text-[hsl(var(--primary))]">
                <BrandLogo size={36} />
                <div className="font-display font-bold text-xl">Vive a lo Grande</div>
            </div>
        </div>
    );
};

export default GoogleCallback;
